 /*
 * Service: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

 /**
  * 
  * 
  * 
  * 
  * 사용하지 않음
  * 
  * 
  * 
  * 
  * 
  * 
  */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleProxy from '../common/proxy';
import language from '../lang';
import GentleServiceOrder from './order';
import GentleAppState from '../common/appstate';
import { getGentleLang } from '../main/main';

var GentleServiceEditSaleDate = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

GentleServiceEditSaleDate.card = function(opt){
    const buttonUpdate = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Title);
    const buttonDetail = GentleLang.translateService(language.product, language.product.type.OrderDetail); 

    const {date, image, badge, name, count, price, pv} = opt;
    const html = `
    <div style="border:solid 1px red">
    <div>${date}</div>
    <image width="100px" src="${image}"></image>
    <div>${badge}</div>
    <div>${name}(${count}개)</div>
    <div>${price}</div>
    <div>${pv}PV</div>
    <button name="update" style="background-color: #4CAF50;">${buttonUpdate}</button>
    <button name="detail" style="background-color: #4CAF50;">${buttonDetail}</button>
    </div>`;
    const $card = $(html);

    $card.find('[name="update"]').bind('click', function(){
        console.log('판매일자 변경하기')
        // todo 
        GentleServiceEditSaleDate.popupEdit();
    });
    $card.find('[name="detail"]').bind('click', function(){
        console.log('주문내역 자세히 보기')
    });

    return $card;
}
 
// 판매일자 변경
/*
2025.2
"example": {
  "request": {
    "method": "POST",
    "url": "https://oadev.atomyn.com/order/changeSaleDate",
    "headers": {
      "Authorization": "Bearer {access_token}",  // 사용자 인증 토큰
      "User-Token": "{userToken}",  // 사용자 토큰
      "siteNo": "{siteNo}",  // 사이트 번호 (예: KR)
      "Content-Type": "application/json"  // 요청 데이터 형식
    },
    "body": {
      "saleNum": "7012502190001047",  // 매출번호
      "salesDate": "2025-02-20"  // 변경할 판매일자 (YYYY-MM-DD)
    }
  },
  "response": [
    {
      "result": "200",  // 응답 코드 (성공)
      "resultMessage": "SUCCESS",  // 응답 메시지
      "siteNo": "KR",  // 요청한 사이트 번호
      "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
      "time": "2025-02-20T12:50:08.719844+09:00[Asia/Seoul]"  // 응답 시간
    },
    {
      "code": "400",  // 응답 코드 (실패)
      "message": "유효한 주문이 아닙니다.",  // 실패 메시지
      "time": "2025-02-20T12:52:51.279+09:00"  // 응답 시간
    }
  ]
}
*/
GentleServiceEditSaleDate.main = function(json){
    const component =  Object.create(this);

    // api
    const request = function(){
        const pageSize = 5;

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.Status){
            case 1:
                const { Data } = data;
                console.log('Data>', Data);    
                render(Data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {};

        proxy.request("schedule", param, onSuccess, onFailed );
    }
    request();

    const render = function(data){
        // 봇버블
        let found = true; // data.productID ? true : false
        {
            let html = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.NotFound, {name});
            if(found) html = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Bot, {name});

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 열거형
        if(found)
        {
            const buttonUpdate = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Title);
            const buttonDetail = GentleLang.translateService(language.product, language.product.type.OrderDetail); 

            // todo : data bind
            let date = '2021-02-21';
            let image = '';
            let badge = '배송중';
            let name = '치약';
            let count = 9;
            let price = '900000';
            price = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(price)});
            let pv = '887766';
            pv = GentleUtil.comma(pv);

            const $card = GentleServiceEditSaleDate.card({date, image, badge, name, count, price, pv});

            component.insertElement($card);
        }

        // button
        if(found)
        {
            const text = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.More);
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        console.log('변경 가능한 주문내역 더보기');
                        GentleServiceEditSaleDate.popupMore(json);
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        else{
            const text = GentleLang.translateService(language.order, language.order.type.List);
            const option = [
                {
                    text: text,
                    user: 'user',
                    onClick: function () {
                        console.log('주문내역보기');
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        GentleUtil.timeStamp();
    };
}

// 판매일자 변경
// 2025.3 판매일자 변경 - 에러 메시지를 처리하는 코드가 주석으로 처리되어 있음???
GentleServiceEditSaleDate.popupEdit = function(saleInfo){
    console.log('GentleServiceEditSaleDate.popupEdit>', saleInfo);
    const { saleNum } = saleInfo;
    const component =  Object.create(this);

    let selectedDate;

    const change = function(data){
        console.log('change>', data);
        const {saleNum, selectedDate} = data;

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            let html;
            switch(data.result){
            case "200":          
                // todo : 
                {
                    const {custName: name} = GentleAppState;
                    // todo : 실패사유를 포함한 버블 메시지 필요
                    html = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Done);
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();    
                }

                break;
            case "500":
                {
                    console.log('매출마감 및 매출가능 정보정책이 없습니다. > ', data.resultMessage);
                    const {custName: name} = GentleAppState;
                    // todo : 실패사유를 포함한 버블 메시지 필요
                    html  = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.ZeroTwo);
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();    
                }
                break;

            case '400':
                console.log('주문정보를 찾을 수 없습니다. > ', data.message);
                html = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.ZeroOne);
                {
                    const {custName: name} = GentleAppState;
                    // todo : 실패사유를 포함한 버블 메시지 필요
                    // const html = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Cant, {name});
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();    
                }

                // 버튼
                {
                    const text = GentleLang.translateService(language.order, language.order.type.List);
                    const option = [
                        {
                            text: text,
                            user: 'user',
                            onClick: function () {
                                console.log('주문내역 보기');
                                // GentleServiceOrder.main();
                            },
                        },
                    ]
                    var button = Object.create( GentleComponentButton);
                    button.createComponent(option);
                    button.insert()
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed >', data);
        }

        const proxy = Object.create(GentleProxy);
        const param = {saleNum,"salesDate": selectedDate};

        // const changeFormData = new FormData();
        // changeFormData.append('id', JSON.stringify(id)); 
        // changeFormData.append('orderAction', JSON.stringify('CHANGE_SALES_DATE'));
        // changeFormData.append('payload', JSON.stringify(param));

        // proxy.requestFormData("global-change", changeFormData, onSuccess, onFailed );
        proxy.requestEx({proxy:"2025-change", param, onSuccess, onFailed, isHidden: true});
    }

    const render = function(daysArray, saleInfo){
        console.log('render daysArray>', daysArray);
        console.log('render saleInfo>', saleInfo);

        const {saleDate, goodsNm, imgPath, totalPrice, totalPV, orderStatus} = saleInfo;
        const dateFormat = new Date(
            saleDate.replace(
                /(\d{4})(\d{2})(\d{2})/,
                '$1-$2-$3'
            )
        );
        const SaleDate = dateFormat.toISOString()
                
        const title = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Title);
        const info = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Info);
        const titleDates = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Dates);
        const buttonTitle = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Select);

        {
            const statusClass = GentleUtil.orderStatusClass(orderStatus.label);
            // todo : data bind
            let date = SaleDate.split('T')[0];

            let price = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: GentleUtil.comma(totalPrice)}) ;

            let pv = GentleUtil.comma(totalPV);

            let html = `
            <div id="sales-date-container">
                <p class="info-box">
                    <img src="/assets/images/atomy/popup_informatino.png" srcset="/assets/images/atomy/popup_informatino@2x.png 2x">
                    ${info}
                </p>
                <p class="notice">처리결과는 이곳을 이용하세요</p>
                <div class="product-container default">
                    <div class="state">
                            <span class="time-label">${date}</span>
                            <i class="at-badge ${statusClass}"></i>
                        </div>
                    <div class="product-card">
                        <figure class="product-thumbnail">
                            <img src="${imgPath}">
                        </figure>
                        <div class="product-summary">
                            <h3>${goodsNm}</h3>
                            <div class="flex-box-2 space-beetween">
                                <span>${price}</span>
                                <span><strong class="pv">${pv}</strong> PV</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <h3>${titleDates}</h3>
                <div class="gentle-button-group date-select">
                    <div class="wide-button" name="dates">
                    </div>
                </div>
                <div class="gentle-button-group date-confirm">
                    <div class="wide-button">
                        <button type="button" class="primary disabled" name="confirm">${buttonTitle}</button>
                    </div>
                </div>
            </div>
            `
            
            const $card = $(html);
            const buttons = [];

            let $buttonConfirm;

            const resetButton = function(){
                // $button1.removeClass('primary');
                // $button2.removeClass('primary');

                // $button1.addClass('secondary');
                // $button2.addClass('secondary');

                // $buttonConfirm.removeClass('disabled');
                // $buttonConfirm.addClass('default');

                buttons.forEach(element => {
                    element.removeClass('primary');
                    element.addClass('secondary');

                    $buttonConfirm.removeClass('disabled');
                    $buttonConfirm.addClass('default');
            });
            }

            // 날짜 
            {
                const $dates = $card.find('[name="dates"]')
                daysArray.forEach(element => {
                    const obj = GentleUtil.timeSplit(element);
                    obj.mm = Number(obj.mm);
                    obj.dd = Number(obj.dd);
                    const {mm: month, dd: day} = obj;
                    const str = GentleLang.translate(GentleLang.type.MonthDate, {month, day});

                    const now = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Now);
                    let $button = $(`<button type="button" class="secondary default">${str}</button>`);
                    if(element === SaleDate) $button = $(`<button type="button" class="primary disabled">${str}(${now})</button>`);
                    
                    $button.bind('click', function(){
                        resetButton();
    
                        $button.removeClass('secondary');
                        $button.addClass('primary');

                        selectedDate = element.split('T')[0];
                    });
    
                    $dates.append($button);
                    buttons.push($button);
                });    
            }

            // click
            $buttonConfirm = $card.find('[name="confirm"]')
            $buttonConfirm.bind('click', function(){
                console.log("변경 일자 선택 완료 : ");

                GentleComponentBubble.insertUserBubble({html:buttonTitle, send:false})
                change({saleNum, selectedDate});

                GentleUtil.removeSlidePopup();
            });

            GentleUtil.createSlidePopup({title, content: $card});
        }
    };

    // ... existing code ...
    const currentDay = new Date(
        saleInfo.saleDate.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3'
        )
    )
// ... existing code ...
    console.log('currentDay>', saleInfo.saleDate, currentDay);
    const daysArray = []
    daysArray.push(currentDay.toISOString()) // 주문날

    const previousDay = new Date(currentDay);
    previousDay.setDate(currentDay.getDate() - 1);

    const nextDay = new Date(currentDay);
    nextDay.setDate(currentDay.getDate() + 1);

    daysArray.unshift(previousDay.toISOString()) // 전날
    daysArray.push(nextDay.toISOString()) // 내일

    render(daysArray, saleInfo);
}

GentleServiceEditSaleDate.popupMore = function(json, data){
    //20221017
    // GentleUtil.updateSSOToken();

    // element 참조 변수 선언
    const cards = [];
    let $list;  // 목록

    // api
    const request = function(PageNo){
        const PageSize = 5;

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.Status){
            case 1:
                const { Data } = data;
                console.log('Data>', Data);
                
                // rows = rows.concat(Data.List);
                // addCard(Data.List);

                // if(Data.List.length > 0){
                //     page += 1;
                //     addCard(Data.List);
                //     rows = rows.concat(Data.List);
                // }
    
                // 기존 요소 업데이트 > 총 카운트 업데이트
                // {
                //     const totalCount = Data.TotalCount;
                //     $total.html(GentleLang.translate(GentleLang.type.AccountTotalIndex, {count: rows.length, total: totalCount}));

                //     console.log('rows.length>', rows.length);
                //     if(rows.length >= totalCount){
                //         console.log('더보기 버튼 비활성화')
                //         console.log('button_more>', $button_more);
                //         $button_more.attr('disabled', true);
                //     }
                // }
    
                render(Data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {PageNo, PageSize};

        proxy.request("schedule", param, onSuccess, onFailed );
    }
    request();

    const render = function(data){
        const array =  [
            {
            },
            {
            },
            {
            },
            {
            },
            {
            },
        ]

        // todo : data bind
        let count = 5;

        // 삽입형
        {
            const title = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.More);
            const comment = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.ListInfo, {count});

            // 더 많은 주문내역 보기
            const button_title = GentleLang.translateService(language.product, language.product.type.OrderMore);

            const html = `
            <div style="border:solid 1px red">
            <div>${title}</div>
            <div>${comment}</div>
            <div class="list"></div>
            <button style="background-color: #4CAF50;">${button_title}</button>
            </div>`;

            let $container = $(html)
            GentleUtil.createSlidePopup({title, content: $container});

            // bind
            $list = $container.find('.list');
            $container.find('button').bind('click',function() {
                var redirectUrl = GentleAppState.isPc ? language.url.pc.ViewMoreOrders : language.url.mobile.ViewMoreOrders;
                    GentleUtil.ssoOpen(redirectUrl);
                console.log('더 많은 주문내역 보기 > 웹');
            });

            // button
            const buttonUpdate = GentleLang.translateService(language.editSaleDate, language.editSaleDate.type.Title);
            const buttonDetail = GentleLang.translateService(language.product, language.product.type.OrderDetail);
            array.forEach(data => {      
                // todo : data bind
                let date = '2021-09-08';
                let image = '';
                let badge = '배송중';
                let name = '치약';
                let count = 9;
                let price = '300000';
                price = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(price)});
                let pv = '555555';

                pv = GentleUtil.comma(pv);
                const $card = GentleServiceEditSaleDate.card({date, image, badge, name, count, price, pv});

                cards.push($card);
        
                $card.find('[name="update"]').bind('click', function(){
                    console.log('퍈매일자 변경 : ', data);
                });
                $card.find('[name="detail"]').bind('click', function(){
                    console.log('주문내역 자세히 보기 : ', data);
                });
        
                $container.find(".list").append($card);
            });       
        }
    };
}

export default GentleServiceEditSaleDate;